import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { OLAF, GREAT_WHITE } from 'HubStyleTokens/colors';
import { HIDE_CONTENTS_TIMEOUT } from '../constants/SidebarConstants';
import CollapseButton from './CollapseButton';
import CollapsableSidebarFadingContent from './CollapsableSidebarFadingContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "CollapsableSidebarContentWrapper__StyledWrapper",
  componentId: "sc-4snt9g-0"
})(["height:100%;width:100%;background-color:", ";border-right:1px solid ", ";"], OLAF, GREAT_WHITE);

/**
 * @description This wrapper handles the sidebar styling and CollapsableSidebar logic
 * allowing children to focus on rendering only the sidebar contents
 */
const CollapsableSidebarContentWrapper = ({
  children,
  collapsed,
  isLocked,
  toggleSidebar,
  collapseButtonPosition,
  showTooltip,
  collapseButtonRef
}) => {
  const [shouldHideContent, setHideContent] = useState(false);
  useEffect(() => {
    let timeout;
    if (collapsed) {
      setHideContent(true);
    } else {
      timeout = setTimeout(() => setHideContent(false), HIDE_CONTENTS_TIMEOUT);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [collapsed]);
  return /*#__PURE__*/_jsxs(StyledWrapper, {
    children: [!collapsed && /*#__PURE__*/_jsx(CollapsableSidebarFadingContent, {
      hide: shouldHideContent,
      className: "width-100 height-100 flex-column justify-between",
      style: {
        zIndex: 5
      },
      children: children
    }), /*#__PURE__*/_jsx(CollapseButton, {
      isLocked: isLocked,
      collapsed: collapsed,
      onClick: toggleSidebar,
      position: collapseButtonPosition,
      showTooltip: showTooltip,
      collapseButtonRef: collapseButtonRef
    })]
  });
};
CollapsableSidebarContentWrapper.displayName = 'CollapsableSidebarContentWrapper';
export default CollapsableSidebarContentWrapper;